import React from "react";
import { MagnifyingGlass } from "phosphor-react";
import { InputWithSuffixFloatingLabel } from "./Shared";

export function SearchInput({
  searchKeywords,
  setSearchKeywords,
  onSearch,
  disabled,
  width,
}) {
  return (
    <InputWithSuffixFloatingLabel
      value={searchKeywords}
      label="Search keywords"
      id="search-keywords-input"
      onChange={(e) => setSearchKeywords(e.target.value)}
      suffix={
        <MagnifyingGlass
          size={16}
          weight="thin"
          color="var(--carter-secondary)"
          onClick={onSearch}
        />
      }
      width={width}
      disabled={disabled}
    />
  );
}
